import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function DiscreteManufacturing() {
  return <DetailPage data={detailPages["discrete-manufacturing"]} />;
}
